import styles from './main.module.scss'

interface Props {
  children?: React.ReactNode;
}
const VerificationLayout = ({ children }: Props) => {
  return (
    <div className={styles.main}>
        <div className={styles.header}>  
            <img src="/jhu-logo.svg" alt="jhu-logo" className={styles.logo}/>
            <img src="/jhu-name.svg" alt="jhu-name" className={styles.name}/>
         
        </div>
        <p className={styles.title}>Online Certificate Verification</p>
        <div className={styles.content}>    
            {children}

        </div>
     
    </div>
  
  )
}

export default VerificationLayout


